var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19761_55133)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19761_55133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 34C66 16.8792 52.1208 3 35 3C17.8792 3 4 16.8792 4 34C4 51.1208 17.8792 65 35 65C52.1208 65 66 51.1208 66 34Z",
    fill: "#2D53DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6552 11H18.3448C14.8407 11 12 13.8407 12 17.3448V50.6552C12 54.1593 14.8407 57 18.3448 57H51.6552C55.1593 57 58 54.1593 58 50.6552V17.3448C58 13.8407 55.1593 11 51.6552 11Z",
    fill: "#2D53DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5567 35.6459L32.5881 52.6257L29.2208 28.6663L51.4953 25.5358L37.5567 35.6459Z",
    fill: "#FF0016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6052 23.6737C37.2766 23.6737 38.6315 22.3188 38.6315 20.6474C38.6315 18.976 37.2766 17.6211 35.6052 17.6211C33.9338 17.6211 32.5789 18.976 32.5789 20.6474C32.5789 22.3188 33.9338 23.6737 35.6052 23.6737Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.21053
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.995 35.6481L39.9636 52.6278L43.3309 28.6684L21.0564 25.5379L34.995 35.6481Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19761_55133",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19761_55133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19761_55133",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19761_55133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay);
export default __webpack_public_path__ + "static/media/PAY.fef1409c49ec1baf7f62f5d922655ff9.svg";
export { ForwardRef as ReactComponent };